<sms-dialog
  [title]="data.title"
  [size]="'sm'"
  [danger]="data.type === 'danger'"
  (close)="onCancel()">
  <div body>
    <p class="sms-confirm-message">{{ data.message }}</p>
  </div>
  <ng-container footer>
    <button type="button" class="secondary-btn" (click)="onCancel()">{{ data.cancelText }}</button>
    <button type="button"
            class="primary-button"
            [class.sms-btn-danger]="data.type === 'danger'"
            (click)="onConfirm()">
      {{ data.confirmText }}
    </button>
  </ng-container>
</sms-dialog>
